"use client";
import React from "react";
import { ArrowRight, MoveRight } from "lucide-react";
import { DotButton, useDotButton } from "./EmblaCarouselDotButton";
import {
  PrevButton,
  NextButton,
  usePrevNextButtons,
} from "./EmblaCarouselArrowButtons";
import "../styles/propertyembla.css";
import useEmblaCarousel from "embla-carousel-react";
import prop1 from "../assets/images/property1.png";
import prop2 from "../assets/images/property2.jpg";

export function InvestmentCarousel(props) {
  const { slides, options, navClass } = props;
  const [emblaRef, emblaApi] = useEmblaCarousel(options);

  const { selectedIndex, scrollSnaps, onDotButtonClick } =
    useDotButton(emblaApi);
  const carouselSteps = [
    {
      background: prop1,
      title: "Designed for the city slicker",
      description: "Property",
      learnMore: "#",
    },
    {
      background: prop2,
      title: "Deposit & Withdraw Funds",
      description: "Savings",
      learnMore: "#",
    },
  ];
  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  } = usePrevNextButtons(emblaApi);

  return (
    <section className="embla__explore">
      <div className="flex justify-between mb-3">
        <div className="flex items-center">
          <p className="text-[14px] text-text-secondary font-semibold">
            New to 80eight
          </p>
        </div>
        <div className="flex">
          <div className="embla__dots__explore">
            {scrollSnaps.map((_, index) => (
              <DotButton
                key={index}
                onClick={() => onDotButtonClick(index)}
                className={`w-1.5 h-1.5 mx-1 rounded-full transition-all duration-200 ${
                  index === selectedIndex
                    ? "bg-gray-800 scale-110"
                    : "bg-gray-300 hover:bg-gray-500"
                }`}
              />
            ))}
          </div>

          <div className="embla__buttons__explore ml-5">
            <PrevButton
              onClick={onPrevButtonClick}
              disabled={prevBtnDisabled}
              navClass={navClass}
            />
            <NextButton
              onClick={onNextButtonClick}
              disabled={nextBtnDisabled}
              navClass={navClass}
            />
          </div>
        </div>
      </div>
      <div className="embla__viewport__explore" ref={emblaRef}>
        <div className="embla__container__explore flex gap-x-4 px-2 w-[1200px]">
          {carouselSteps.map((step, index) => (
            <div
              className="embla__slide__explore ml-2 relative h-64 md:h-96 w-full flex-shrink-0 rounded-2xl overflow-hidden"
              key={index}
            >
              <img
                src={step.background}
                alt={step.description}
                className="absolute inset-0 object-cover w-full h-full"
              />

              <div className="absolute inset-0 bg-gradient-to-t from-black/100 to-transparent z-10"></div>

              <div className="absolute bottom-4 left-4 z-20 text-white text-left px-4">
                <h3 className="text-2xl md:text-4xl font-semibold mb-2">
                  {step.title}
                </h3>
                <p className="text-sm md:text-base mb-4">{step.description}</p>
                <a
                  href={step.learnMore}
                  className="inline-flex items-center gap-1 text-white py-2 rounded transition duration-200 ease-in-out hover:translate-x-1"
                >
                  Learn More
                  <ArrowRight className="w-4 h-4 transition-transform duration-200 ease-in-out group-hover:translate-x-1" />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
